export enum UpdatePackageAssociationEnum {
    all,
    partial,
    none,
}
